import { render } from "./MobileNav.vue?vue&type=template&id=afac0cd6&scoped=true"
import script from "./MobileNav.vue?vue&type=script&lang=js"
export * from "./MobileNav.vue?vue&type=script&lang=js"

import "./MobileNav.vue?vue&type=style&index=0&id=afac0cd6&scoped=true&lang=css"
import "./MobileNav.vue?vue&type=style&index=1&id=afac0cd6&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afac0cd6"]])

export default __exports__